import React, { useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import { useParams, useLocation, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import {
  goodsViewAction,
  purchaseItemsGetAction,
  purchaseReturnItemsGetAction,
} from "../../../redux/actions/purchase-action";
import CreateEditViewGrn from "../../../components/purchase-section/goods-receipt/create-edit-view-grn";

const GoodsReceipt = () => {
  const location = useLocation();
  const values = location.state?.values || [];
  const { itemData, ...rest } = values;
  const { itemId, type } = useParams();
  const itemIdArray = JSON.parse(decodeURIComponent(itemId));
  const [searchParams] = useSearchParams();
  const transfer=searchParams.has("transfer");
  //

  const cloneID = searchParams.get("cloneID");
  const isClone = cloneID ? true : false;
  //
  const allitems = itemIdArray.map((item) => {
    const { cmr_id, ...rest } = item;
    return rest;
  });
  const [orderDetail, setOrderDetail] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    if (isClone) {
      setLoading(true);
      dispatch(goodsViewAction(cloneID, onCloneSuccPur, onErrPur));
    } else if (allitems?.length > 0) {
      if (type === "return") {
        setLoading(true);
        dispatch(purchaseReturnItemsGetAction(allitems, onSuccPur, onErrPur));
      } else {
        setLoading(true);
        dispatch(purchaseItemsGetAction(allitems, onSuccPur, onErrPur));
      }
    }
  }, []);

  const onCloneSuccPur = (data) => {
    setOrderDetail(data?.data?.[0]);
    setLoading(false);
  };
  const onSuccPur = (data) => {
    setOrderDetail(data?.data);
    setLoading(false);
  };

  const onErrPur = (data) => {
    setLoading(false);
  };

  const orderData = orderDetail?.orderData || {};
  const vendorDetails = orderDetail?.vendorDetails?.[0] || {};

  const prefix = searchParams.get("type") || "pot";
  const isNew = searchParams.has("new");

  return (
    <InnerLayout backBtn={true} title={`${isClone ? "Clone" : "Add"} Goods Receipt`}>
      {loading ? (
        <LoadingSpinner />
      ) : (
        // <GoodsRecComp
        <CreateEditViewGrn
          isClone={isClone}
          setLoading={setLoading}
          setOrderDetail={setOrderDetail}
          // payto={vendorDetails?.pot_pay_to_address}
          // shipto={vendorDetails?.pot_ship_to_address}
          clickedplus={isNew}
          payto={
            isClone
              ? orderDetail?.orderData?.gort_pay_to_address
              : vendorDetails?.[`${prefix}_pay_to_address`]
          }
          shipto={
            isClone
              ? orderDetail?.orderData?.gort_ship_to_address
              : vendorDetails?.[`${prefix}_ship_to_address`]
          }
          page="add"
          pageType="grn"
          type={type}
          orderDetail={
            values?.itemData?.length > 0
              ? values?.itemData
              : orderDetail?.itemData
          }
          transfer={transfer===true}
          vendorDetails={
            isClone
              ? [{ ...orderData, customer_invoice_number: "" }]
              : values?.itemData?.length > 0
              ? [rest]
              : [
                  {
                    ...vendorDetails,
                    gort_sub_total: orderData?.sub_total,
                    gort_total_gst: orderData?.total_tax,
                    gort_total_discount: orderData?.total_discount,
                    gort_total_amount: orderData?.total_amount,
                    gort_round_off_value: orderData?.round_off_value,
                    gort_tcs_or_tds_amount: orderData?.tcs_or_tds_amount,
                    gort_tcs_or_tds_percentage_id:
                      orderData?.tcs_or_tds_percentage_id,
                    gort_tcs_or_tds_percentage:
                      orderData?.tcs_or_tds_percentage,
                    gort_tds_tcs_type: orderData?.tcs_or_tds_type,
                    gort_is_invoice_dis_percentage:
                      orderData?.is_invoice_dis_percentage ?? true,
                    gort_invoice_discount: orderData?.invoice_discount ?? 0,
                    gort_invoice_discount_percentage:
                      orderData?.invoice_discount_percentage ?? 0,
                  },
                ]
          }
        />
      )}
    </InnerLayout>
  );
};

export default GoodsReceipt;
